import { useAlert } from 'hooks/useDialog'
import { useCallback } from 'react'
import { checkFilesErrors } from 'utils/file'

type CheckFiles = (files: File[]) => boolean

function useCheckFiles() {
  const alert = useAlert()

  const checkFiles: CheckFiles = useCallback(
    (files) => {
      const errors = checkFilesErrors(files, true)

      if (errors.length === 0) {
        return true
      }

      alert({ message: errors[0] })
      return false
    },
    [alert],
  )

  return checkFiles
}

export default useCheckFiles
